import { IS_ACCELERATED_CURRICULUM_FILTER } from 'constants/assignments';

export const GRADE_OPTIONS = [
  { value: 0, key: 'Kindergarten' },
  { value: 0, key: 'Grade K' },
  { value: 1, key: 'Grade 1' },
  { value: 2, key: 'Grade 2' },
  { value: 3, key: 'Grade 3' },
  { value: 4, key: 'Grade 4' },
  { value: 5, key: 'Grade 5' },
  { value: 6, key: 'Grade 6' },
  { value: 7, key: 'Grade 7' },
  { value: 8, key: 'Grade 8' },
  { value: 9, key: 'Algebra 1' },
  { value: 9, key: 'ALG 1' },
  { value: 10, key: 'Geometry' },
  { value: 11, key: 'Algebra 2' }
];

const generateSequentialOptions = (prefix, maxCount) => {
  return Array.from({ length: maxCount }, (_, i) => {
    const num = i + 1;
    return {
      value: num,
      key: `${prefix} ${num}`
    };
  });
};

const MAX_UNITS = 9;
const MAX_LESSONS = 21;

export const UNIT_OPTIONS = generateSequentialOptions('Unit', MAX_UNITS);
export const LESSON_OPTIONS = generateSequentialOptions('Lesson', MAX_LESSONS);

export const getInitialAcceleratedState = () => {
  try {
    const storedValue = localStorage.getItem(IS_ACCELERATED_CURRICULUM_FILTER);
    return storedValue !== null ? JSON.parse(storedValue) : false;
  } catch (error) {
    console.error('Error parsing accelerated filter from local storage', error);
    return false;
  }
};
